import React from "react";
import "./fontpage.css"; // Optional: For adding styles


const Fontpage = () => {
    return (
        <>
            <div className="AppA" >
                <div className="paragraphfont">
                    <ul className="numbered-list">
                        <li className="paragraphf1">Company Overview</li>
                        <li className="paragraphf2">Company Overview</li>
                        <li className="paragraphf3">Company Overview</li>
                        <li className="paragraphf4">Company Overview</li>
                        <li className="paragraphf5">Company Overview</li>
                        <li className="paragraphf6">Company Overview</li>
                        <li className="paragraphf7">Company Overview</li>
                        <li className="paragraphf8">Company Overview</li>
                        <li className="paragraphf9">Company Overview</li>
                        <li className="paragraphf10">Company Overview</li>
                        <li className="paragraphf11">Company Overview</li>
                        <li className="paragraphf12">Company Overview</li>
                        <li className="paragraphf13">Company Overview</li>
                        <li className="paragraphf14">Company Overview</li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export default Fontpage;

